import { required, optional, obj, array } from 'AppReact/schema';

export default {
    isOpen: required('boolean'),
    name: optional('string'),
    nameError: optional('string'),
    monthlyMax: optional('number'),
    points: optional('number'),
    active: optional('boolean')
}

export const defaultNewRewardCategoryModalState = {
    isOpen: false,
    name: '',
    nameError: '',
    monthlyMax: null,
    points: null,
    active: true
}
